import React, { useEffect, useState } from "react";
import { CommonModal } from "../../AbstractElements";
import { useForm, useController } from "react-hook-form";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import Select from "react-select";
import { blockCar, getblockCarDetails, unblockCar } from "../../Services/Car.service";
import moment from "moment";
import { showAlert } from "../../Services/Shared.service";
const BlockUnblockModal = ({
  isblocked,
  carDetails,
  fetchData,
  LargeModaltoggle,
  Large,
  title,
  setShowApiLoader
}) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm(
    {
      defaultValues: {
        detailed_reason: ""
      }
    }
  );

  console.log("car details", carDetails)

  const [blockCarData, setBlockCarData] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (isblocked && carDetails.carNo) {
      getblockCarDetails(carDetails.carNo).then(result => {
        if (result.data) {
          setBlockCarData(result.data)
        }
      }).catch(err => {
        setShowApiLoader(false);
        showAlert('error', err.response?.data?.message ? err.response.data.message : 'Something went wrong');
      })
    }
  }, [isblocked, carDetails.carNo])


  const onSubmit = (formValues) => {
    setIsSubmitting(true)
    if (isblocked) {
      const obj = {
        id: blockCarData.id,
        unavailableDate: new Date(),
        approxAvailableDate: blockCarData.approxAvailableDate, // set from detail
        actualAvailableDate: null,
        approxAvailableTime: null,
        reason: blockCarData.reason,
        blockedReason: blockCarData.reason,
        unblockedReason: formValues.detailed_reason,
        createdOn: blockCarData.createdOn,
        createdById: blockCarData.createdById,
        carNo: carDetails.carNo,
        isResolved: true,
        availableById: null,
        availableByName: null,
        createdByName: blockCarData.createdByName,
        isautoUnBlock: false
      };
      setShowApiLoader(true);
      unblockCar(obj).then(result => {
        setIsSubmitting(false)
        setShowApiLoader(false);
        showAlert('success', 'Car unblocked Successfully');
        fetchData()
        reset({
          detailed_reason: ""
        })
        LargeModaltoggle()
      }).catch(err => {
        setIsSubmitting(false)
        setShowApiLoader(false);
        showAlert('error', err.response?.data?.message ? err.response.data.message : 'Something went wrong');
      })
    } else {
      const aYearFromNow = new Date();
      aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
      const obj = {
        unavailableDate: null,
        approxAvailableDate: moment(aYearFromNow).format("YYYY-MM-DD"), //after one year
        actualAvailableDate: null,
        reason: formValues.detailed_reason,
        blockedReason: formValues.detailed_reason,
        createdOn: null,
        createdById: null,
        carNo: carDetails.carNo,
        id: null,
        approxAvailableTime: new Date(aYearFromNow.setUTCHours(23, 59, 59, 999)) // after one year , end of the day
      };
      setShowApiLoader(true);
      blockCar(obj).then(result => {
        setIsSubmitting(false)
        setShowApiLoader(false);
        showAlert('success', 'Car blocked Successfully');
        fetchData()
        reset({
          detailed_reason: ""
        })
        LargeModaltoggle()
      }).catch(err => {
        setIsSubmitting(false)
        setShowApiLoader(false);
        showAlert('error', err.response?.data?.message ? err.response.data.message : 'Something went wrong');
      })
    }
  };

  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={() => {
        reset({
          detailed_reason: ""
        })
        LargeModaltoggle()
      }}
      size="md"
    >
      <Row className="cancel-booking">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-12 col-form-label">Remarks</Label>
            <Col lg="12">
              <textarea
                className="form-control"
                {...register("detailed_reason", {
                  required: {
                    value: true,
                    message: "Remarks is required"
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.detailed_reason?.message}</span>
            </Col>
          </FormGroup>
          <Row className="submit-booking">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              Submit
            </button>
          </Row>
        </Form>
      </Row>
    </CommonModal>
  );
};

export default BlockUnblockModal;
